import React, { useState, useEffect } from 'react';

const timer = 2000; // 3 seconds    

const VideoBadge = ({ badgeImageSrc, badgeImageAlt }: { badgeImageSrc: string | undefined, badgeImageAlt: string | undefined }) => {
  
    const [badgeVisible, setBadgeVisible] = useState(false);
  // Toggle visibility every 3 seconds for demonstration
  useEffect(() => {
    const interval = setInterval(() => {
      setBadgeVisible(true);
    }, timer);

    return () => clearInterval(interval);
  }, []);

  const badgeStyles = `
    w-36 hidden lg:block lg:w-52 transition-all duration-1000 ease-in-out
    ${badgeVisible 
      ? 'opacity-100 translate-x-0' 
      : 'opacity-0 -translate-x-[30px]'
    }
  `;

  return (

      <div className={badgeStyles}>
        <img 
          src={badgeImageSrc} 
          alt={badgeImageAlt}
          className="w-full rounded-lg"
        />
      </div>
  );
};

export default VideoBadge;